import { render, staticRenderFns } from "./ReviewCard_origin.vue?vue&type=template&id=3d7b3d3e"
import script from "./ReviewCard_origin.vue?vue&type=script&lang=js"
export * from "./ReviewCard_origin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports